// realtime 鮮度表示の「N 分前」を、再フェッチせずにクライアント側で更新する progressive enhancement。
// サーバが絶対時刻 (HH:MM) を描画済みなので、相対表記 (.realtime-freshness__rel) のみ 30 秒毎に再計算する。
// 60 分以上は「1時間以上前」固定（無限 stale 回避・サーバ FreshnessHelper#realtime_relative_text と一致）。
const RELATIVE_LIMIT_SEC = 3600

function relativeText(diffSec) {
  if (diffSec < 60) return 'たった今'
  if (diffSec < RELATIVE_LIMIT_SEC) return `${Math.floor(diffSec / 60)} 分前`
  return '1時間以上前'
}

function updateAll() {
  const now = Date.now()
  document.querySelectorAll('[data-freshness-at]').forEach((el) => {
    const iso = el.getAttribute('data-freshness-at')
    if (!iso) return
    const parsed = Date.parse(iso)
    if (Number.isNaN(parsed)) return
    const diffSec = Math.max(Math.floor((now - parsed) / 1000), 0)
    const rel = el.querySelector('.realtime-freshness__rel')
    if (rel) rel.textContent = `（${relativeText(diffSec)}）`
  })
}

window.addEventListener('load', () => {
  updateAll()
  setInterval(updateAll, 30000)
})
